import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./HeaderComponent.css";
import UserUtilityBar from "../../../CustomerDashboard/WelcomeHeader/Notifications/UserUtilityBar";
import { useDispatch } from "react-redux";
import { GetUserNotificationsServiceInit } from "../../../../store/Notifications/UserNotificationSlice";
const HeaderComponent = (props) => {
    const { title, description = null, showUtility = true } = props;
    const dispatch = useDispatch();
    const didFetch = useRef(false);
    const location = useLocation();

   useEffect(() => {
  if (location.pathname.includes("/dashboard")) {
     if (didFetch.current) return;
        didFetch.current = true;
        dispatch(GetUserNotificationsServiceInit(4));
    }
  // eslint-disable-next-line
}, []);

    return (
        <div className='header-component'>
            <div className="header-title-container">
                <div className="title-desc-container">
                    <div className="header-title">
                        {title}
                    </div>
                    <div className='header-description'>
                        {description}
                    </div>
                </div>
                {showUtility && <div className='header-search-component'>
                    <UserUtilityBar></UserUtilityBar>
                </div>}
            </div>
            <div className='header-bar'>
                <span className="header-segments mid-blue"></span>
                <span className="header-segments dark-blue"></span>
                <span className="header-segments violet"></span>
                <span className="header-segments dark-violet"></span>
                <span className="header-segments crimson"></span>
                <span className="header-segments dark-crimson"></span>
                <span className="header-segments dark-pastel"></span>
            </div>
        </div>
    );
};

export default HeaderComponent;